import { Container, Row, Col } from "reactstrap";
import bigCloud from "assets/images/big-cloud.svg";
import shapeDots2 from "assets/images/shape-dots2.svg";
import whiteStar from "assets/images/white-star.svg";
import blueStar from "assets/images/blue-star.svg";
import shapeFinger from "assets/images/shape-finger.svg";
import loginCta from "assets/images/LoginCta.svg";
import { ReactComponent as ArrowIcon } from "assets/images/arrow-left.svg";
import { Route, Switch, Redirect } from "react-router-dom";
import AUTH_ROUTES from "constants/AuthRoutes";

function Auth() {
  /*   componentDidMount() {
    if (localStorage.getItem("access_token")) this.props.history.push("/"); //If there was token, go to the home page
  } */

  return (
    <Container fluid={true} className="login-body">
      <Row>
        <Col md={7} className="login-body-right-box">
          <div className="login-body-right">
            <div className="mx-auto">
              {/* {this.getCurrentTab()} */}
              <Switch>
                {AUTH_ROUTES.map(item => (
                  <Route key={item.path} {...item} />
                ))}
                <Route component={() => <Redirect to="/auth/SignIn" />} />
              </Switch>
            </div>
          </div>
        </Col>
        <Col md={5} className="p-0 login-body-left-box">
          <div className="login-body-left">
            <img src={bigCloud} alt="شکل ابر" className="big-cloud img-fluid" />
            <img
              src={bigCloud}
              alt="شکل ابر"
              className="small-cloud img-fluid"
            />
            <img
              src={shapeDots2}
              alt="شکل نقطه چین"
              className="shape-dots-top img-fluid"
            />
            <img
              src={whiteStar}
              alt="ستاره سفید"
              className="white-star-top img-fluid"
              style={{ display: "none" }}
            />
            <img
              src={shapeFinger}
              alt="شکل اثر انگشت"
              className="shape-finger img-fluid"
              style={{ display: "none" }}
            />
            <img
              src={whiteStar}
              alt="ستاره سفید"
              className="white-star-bottom img-fluid"
            />
            <img
              src={blueStar}
              alt="ستاره آبی"
              className="blue-star img-fluid"
              style={{ display: "none" }}
            />
            <img
              src={shapeDots2}
              alt="شکل نقطه چین"
              className="shape-dots-bottom img-fluid"
            />

            <div className="profile-box">
              <div className="profile-box-in">
                <div className="profile-pic-box mb-3">
                  <img
                    src={loginCta}
                    alt="پروفایل"
                    className="profile-pic  img-fluid"
                  />
                </div>
                <div className="profile-desc-box">
                  <div className="profile-desc-title">
                    <span className="big-title">
                      چه مواقعی باید از لندینگ پیج استفاده کرد؟
                    </span>
                  </div>
                  <div className="profile-desc mt-3">
                    همه ما می‌دانیم وقتی میخواهیم یک کمپین دیجیتال اجرا کنیم
                    متناسب با هدف کمپین و مخاطبان نیاز به یک لندینگ پیج
                    استاندارد داریم که نرخ تبدیل مناسبی داشته باشد. شما در لندین
                    می‌توانید براساس ساختار و چارچوب‌های تعیین شده با هویت بصری
                    و پکیج‌های تصویرسازی آماده لندینگ پیج خود را بسازید. لندینگ
                    پیج خود را می‌توانید به راحتی به سایر سرویس ها از جمله گوگل
                    آنالیتیکس، تک منیجر، رایچت، یکتانت متصل کنید تا بتوانید
                    عملکرد بهتری را تجربه کنید.
                  </div>
                  <a
                    href="https://landin.ir/how-do-make-landing-page-with-landin/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div
                      className="profile-desc mt-3"
                      style={{
                        textAlign: "left",
                        cursor: "pointer",
                        fontWeight: 300,
                      }}
                    >
                      چطوری بسازم
                      <ArrowIcon style={{ marginRight: 10 }} />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Auth;
